// extracted by mini-css-extract-plugin
export default {"dropdownItemCustom":"NavbarDropdown_dropdownItemCustom__a3srX","spanCustom":"NavbarDropdown_spanCustom__2EfXa","listItem":"NavbarDropdown_listItem__t9vFV"};